import _ from 'underscore';
import { BaseAccountsSchemaProcessor } from './base-accounts-schema-processor';

export class ManagementSchemaProcessor extends BaseAccountsSchemaProcessor {
  constructor(options) {
    const propWhitelist = _.compact([
      'Name',
      'Currency',
      'AccountType',
      'Owner',
      'BillToCustomerName',
      'Budget/DailyBudget',
      'Balance',
      'PaymentInstrumentType',
      'PreferredUserName',
      'AccountVerificationStatus',
      'BusinessLegalName',
    ]);
    super(options, { propWhitelist });
    const { dynamic } = this.Permissions;
    const IsChinaMarket = dynamic ? dynamic.CNMarketExpansion : false;
    this.isChinaMarket = IsChinaMarket;
  }

  getAdditionalSchemaProperties() {
    const additionalProperties = {};

    if (this.Permissions && this.Permissions.dynamic && this.Permissions.dynamic.CBTLifetimeBudget) {
      additionalProperties.LifetimeBudget = {
        title: this.passedInI18n.getString('ColumnName_CampaignLifetimeBudget'),
        property: 'Budget/LifetimeBudget',
        type: 'number',
        minimum: 0,
        filterable: true,
      };
    }

    return additionalProperties;
  }

  getOverridenSchemaProperties() {
    /* By design, filter fail or verified should also return overrideFailed and overrideVerified
    status from the query, so we filter the overrides status out here and add them in the query
    bellow, c.f. odataOptions.custom */
    // TODO: [jingl] comment this line to temporarily resolve build issue. Will fix later.
    // const aivStatusEnumValues =
    //   _.values(_.omit(AccountVerificationStatus, 'OverrideFailed', 'OverrideVerified'));
    const aivStatusEnumValues = this.isChinaMarket ? [61, 62, 63, 64, 65, 66] : [1, 3, 4, 5, 6, 8, 9];

    return {
      PaymentInstrumentType: {
        // MT has type int, we need to override it is since all filters
        // value must be string for the type select
        type: 'string',
        // BUG 2245709: Override default [eq] operator because jsdata won't recognise it
        // due to the type select returns an array. In other words: jsdata predicate,
        // { where: $eq: [...values] } crash so we need to use $in: [...values] and
        // override the URL statement in odataOptions.custom)
        operators: ['in'],
        operatorDisplayNameMap: {
          in: this.passedInI18n.getString('Filter_Operator_EQ'),
        },
      },
      AccountVerificationStatus: {
        title: this.passedInI18n.getString('ColumnName_AccountVerificationStatus'),
        enum: aivStatusEnumValues,
        enumType: 'AccountVerificationStatus',
        enumValueMap: {},
        localized: _.object(aivStatusEnumValues, _.map(aivStatusEnumValues, value => this.i18n.getString(`AccountVerificationStatus_${value}`))),
        // Same as PaymentInstrumentType, we need to override it to string to make filter work
        type: 'string',
        operators: ['in'],
        chooseType: 'checkbox',
        filterable: true,
      },
      BusinessLegalName: {
        title: this.passedInI18n.getString('ColumnName_BusinessLegalName'),
      },
    };
  }

  updateOdataOptions(odataOptions) {
    super.updateOdataOptions(odataOptions);

    _.extendOwn(odataOptions.custom, {
      PaymentInstrumentType: {
        eq: (value) => {
          const intValue = value.split("'")[1];
          const url = `PaymentInstrumentType eq ${intValue}`;
          return url;
        },
      },
      AccountVerificationStatus: {
        eq: (value) => {
          let url = `AccountVerificationStatus eq ${value}`;
          if (value === 1) { // AccountVerificationStatus.Failed
            url += ' or AccountVerificationStatus eq 2'; // AccountVerificationStatus.OverrideFailed
          }
          if (value === 6) { // AccountVerificationStatus.Verified
            url += ' or AccountVerificationStatus eq 7'; // AccountVerificationStatus.OverrideVerified
          }
          return url;
        },
      },
    });

    return odataOptions;
  }
}
